module.exports = __webpack_public_path__ + "img/winerackdog29.98e25d2b.jpg";